import { Body, H5, Overline, Stack } from '@qred/components-library';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import { StepperHeaderProps } from '~/Interfaces';

interface StepHeaderProps extends StepperHeaderProps {
  shouldTranslate?: boolean;
}

const StepHeader = ({
  title,
  description,
  overline,
  shouldTranslate = true,
}: StepHeaderProps) => {
  const translate = useTranslate();

  return (
    <>
      {(title || description) && (
        <Stack spacing="md">
          <Stack spacing="md">
            {!!overline && (
              <Overline data-testid="title-overline" data-record>
                {shouldTranslate ? translate(overline) : overline}
              </Overline>
            )}
            {!!title && (
              <H5 data-testid="title" data-record>
                {shouldTranslate ? translate(title) : title}
              </H5>
            )}
          </Stack>
          {!!description && (
            <>
              {typeof description === 'string' ? (
                <Body
                  size="md"
                  data-testid="description"
                  color="Text/Secondary"
                >
                  {shouldTranslate
                    ? translate(description, {
                        lineBreak: <br />,
                      })
                    : description}
                </Body>
              ) : (
                description
              )}
            </>
          )}
        </Stack>
      )}
    </>
  );
};

export default StepHeader;
